export default "__VITE_ASSET__K8qIzC3B__"